import { ShieldOff } from "lucide-react";
import type { PermissionKey } from "@grizzly/shared";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../lib/session.js";
import { Button } from "./ui/button.js";
import { EmptyState } from "./ui/states.js";
import { Skeleton } from "./ui/states.js";

export function RequireAuth() {
  const { status } = useSession();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div className="mx-auto max-w-md py-16">
        <Skeleton rows={6} />
      </div>
    );
  }
  if (status === "anonymous") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return <Outlet />;
}

export function RequirePermission({
  permission,
  children,
}: {
  permission: PermissionKey;
  children: React.ReactNode;
}) {
  const { user } = useSession();
  if (!user) return null;
  if (!user.permissions.includes(permission)) {
    return (
      <EmptyState
        icon={ShieldOff}
        title="Not available for your role"
        description="Your account does not have permission for this area. If you believe this is wrong, ask the owner to review role settings."
        action={
          <Button asChild variant="secondary">
            <Link to="/">Back to dashboard</Link>
          </Button>
        }
      />
    );
  }
  return <>{children}</>;
}
